module.exports = __webpack_public_path__ + "img/language.30a2184.svg";